import React from 'react';

import CampaignsLinksTable from 'scenes/Campaigns/GGCampaigns/components/CampaignsLinksTable';

const GGLinkSection = ({ campaignLinks = [] }) => (
  <CampaignsLinksTable campaignLinks={campaignLinks} withCopyParams={true} />
);

export default GGLinkSection;
